import React, { Component } from 'react'
import { connect } from 'shalala';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../../store';
import RecepcionFilesList from './list/RecepcionFilesList';
import SearchByDatesAndKeyword from '../../../shared/SearchByDatesAndKeyword';
import RecepcionFilesListActions from './list/components/RecepcionFilesListActions';

class RecepcionFiles extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('Recepción y Validación');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnRowClick = (data) => {
    this.props.history.push({
      pathname: `/modulos/recepcion/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  }

  handleOnKeywordChange = (search) => {
    this.props.paginate({ search });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to } = this.props.pagination;

    return (
      <>
        <Row>
         <Col sm="auto" md="8" className="mb-2">
            { selectedRowKeys.length === 0 && (
              <SearchByDatesAndKeyword
                from={ from }
                to={ to }
                onDateChange={ this.handleOnDateChange }
                onKeywordChange={ this.handleOnKeywordChange }
              />
            )}
          </Col>

          <Col sm="auto" md="4" className="text-right pb-2">
            <RecepcionFilesListActions />
          </Col>
        </Row>

        { Guardian.allows('prefactura.listar') && (
          <RecepcionFilesList
            onRowClick={ this.handleOnRowClick }
            selectedRowKeys={ selectedRowKeys }
            selectedRows={ selectedRows }
            onRowSelectionChange={ this.handleOnRowSelectionChange }
          />
        )}
      </>
    )
  }
}

const mapState = (state) => {
  return state.modulo.recepcion.list
}

const mapActions = (actions) => {
  return {
    paginate: actions.modulo.recepcion.list.paginate,
  };
}

export default connect(useStore, mapState, mapActions)(RecepcionFiles);